import gql from 'graphql-tag';

export const MANAGER_CONTENT_QUERY = gql`
  query managerContent($slug: String!) {
    exploreCategory(slug: $slug) {
      id
      title
      slug
      internalName
      colourTheme
      summary
      subCategories {
        id
        internalName
        title
        slug
        summary
        content {
          ... on Series {
            id
            title
            slug
            subtitle
            cloudinaryThumbnail {
              path
            }
            totalDays
            daysCompleted
            exploreCategory {
              id
              title
              slug
              internalName
              colourTheme
            }
          }
          ... on Tool {
            id
            title
            summary
            slug
            estimatedMins
            cloudinaryThumbnail {
              path
            }
            mediaType {
              value
            }
            isFavourite
            exploreCategory {
              id
              slug
              colourTheme
              internalName
            }
          }
        }
      }
    }
    getAssetToken(input: { isMobile: false }) {
      assetToken
    }
  }
`;
